import { absolutePath } from "./absolutePath";

interface TopicsFnProps {
  params?: Record<string, unknown>;
  spaceId?: string | number;
}

export const topics = {
  communityMemberTopics: ({ params = {} }: TopicsFnProps) =>
    absolutePath(`topics`, params),
  spaceTopics: ({ spaceId, params = {} }: TopicsFnProps) =>
    absolutePath(`spaces/${spaceId}/topics`, params),
};
